<template>
  <div>
    <a-spin :spinning="vnplot_visible" :indicator="indicator">
      <a-row :gutter="[8, 24]" style="margin-top: 20px">
        <!-- <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }">
        Step 1: Choose perturbed-gene list
        <a-select
          v-model="value"
          mode="multiple"
          style="width: 100%; margin-top: 5px"
          placeholder="select one or more perturbed gene"
          option-label-prop="label"
        >
          <a-select-option
            v-for="gene in this.genelist"
            :key="gene"
            :label="gene"
          >
            {{ gene }}
          </a-select-option>
        </a-select>
      </a-col> -->
        <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 24 }">
          Step 1: Input a gene name
          <a-tooltip>
            <template slot="title">
              Click to access the genes contained in this study.
            </template>
            <a :href="this.yaxis" target="_blank">
              <a-icon type="eye" style="color: red; font-weight: bolder"
            /></a>
          </a-tooltip>
          <a-input
            v-model="chooseGene"
            style="width: 100%; margin-top: 5px"
            placeholder="Input a gene name"
          >
          </a-input>
        </a-col>

        <a-col :span="24" :gutter="[12, 24]">
          <a-row>
            <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }">
              Step 2: Customize the color palette:
              <div @click="colorInputClick" style="margin-top: 5px">
                <a-input
                  disabled
                  :value="color"
                  @click="colorInputClick"
                  addon-before="Treatment Color :"
                ></a-input>
              </div>
              <div v-show="isShowColors" class="color-select-layer">
                <sketch-picker
                  v-model="color"
                  @input="colorValueChange"
                ></sketch-picker>
              </div>

              <div @click="colorInputClick2" style="margin-top: 5px">
                <a-input
                  disabled
                  :value="color2"
                  @click="colorInputClick2"
                  addon-before="NT Color :"
                ></a-input>
              </div>
              <div v-show="isShowColors2" class="color-select-layer">
                <sketch-picker
                  v-model="color2"
                  @input="colorValueChange2"
                ></sketch-picker>
              </div>
            </a-col>
            <a-col
              :sm="{ span: 24 }"
              :md="{ span: 24 }"
              :xl="{ span: 12 }"
              style="margin-top: 5px"
            >
              <span>Other option:</span>

              <ul style="line-height: 35px">
                <li>
                  1. Log
                  <a-tooltip>
                    <template slot="title">
                      Plot the feature axis on log scale, default No
                    </template>
                    <a-icon type="question-circle" :style="{ color: 'red' }" />
                  </a-tooltip>
                  :
                  <a-radio-group
                    name="loggroup"
                    :default-value="1"
                    v-model="doLog"
                    @change="changeLog"
                  >
                    <a-radio :value="1"> Yes </a-radio>
                    <a-radio :value="0"> No </a-radio>
                  </a-radio-group>
                </li>
                <li>
                  2. Dimensions:
                  <a-row>
                    <a-col :span="12">
                      <a-input
                        type="text"
                        addon-before="Width : "
                        v-model="pWidth"
                    /></a-col>
                    <a-col :span="12">
                      <a-input
                        type="text"
                        addon-before="Height: "
                        v-model="pHeight"
                    /></a-col>
                  </a-row>
                </li>
                <li v-if="false">
                  2. Show non-perturbed cell group
                  <a-tooltip>
                    <template slot="title">
                      Plot the non-perturbed cell feature on axis, default No
                    </template>
                    <a-icon type="question-circle" :style="{ color: 'red' }" />
                  </a-tooltip>
                  :
                  <a-radio-group
                    name="npgroup"
                    :default-value="0"
                    v-model="doNP"
                    @change="changeNP"
                  >
                    <a-radio :value="1"> Yes </a-radio>
                    <a-radio :value="0"> No </a-radio>
                  </a-radio-group>
                </li>
              </ul>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-button
        type="primary"
        style="text-align: right; margin-top: 5px"
        @click="vnplot()"
        >Plot</a-button
      >
      <a-card
        style="width: 100%; margin-top: 10px; height: 550px"
        v-show="visible"
      >
        <!-- <a-spin
          size="large"
          :spinning="vnplot_visible"
          tip="Plotting... please wait ~"
        > -->
        <object :data="this.vnplotlinks" width="100%" height="500"></object>
        <!-- </a-spin> -->
      </a-card>
    </a-spin>
  </div>
</template>

<script>
import axios from "axios";
import { Sketch } from "vue-color";
export default {
  methods: {
    //取色器
    // 颜色输入框点击事件处理1
    colorInputClick() {
      this.isShowColors = !this.isShowColors;
    },
    colorInputOut() {
      this.isShowColors = !this.isShowColors;
    },
    // 颜色值改变事件处理
    colorValueChange(val) {
      console.log(val);

      // 取颜色对象的十六进制值
      this.color = val.hex;
    },
    // 颜色输入框点击事件处理2
    colorInputClick2() {
      this.isShowColors2 = !this.isShowColors2;
    },
    colorInputOut2() {
      this.isShowColors2 = !this.isShowColors2;
    },
    // 颜色值改变事件处理
    colorValueChange2(val) {
      console.log(val);

      // 取颜色对象的十六进制值
      this.color2 = val.hex;
    },
    //绘图函数
    vnplot() {
      if (this.chooseGene.length != 0) {
        this.visible = true;
        this.vnplot_visible = true;
        this.vnplotlinks = null;
        // console.log(this.$route.query.datasetId);
        // console.log(String(this.value));
        // console.log(String(this.chooseGene));
        ///console.log(String(this.color).split("#")[1]);
        //console.log(String(this.color2).split("#")[1]);
        // console.log(String(this.doLog));
        // console.log(String(this.doNP));
        axios
          .get("http://research.gzsys.org.cn/perturbdb/API/plot/01vnplot.php", {
            params: {
              datasetId: this.$route.query.datasetId,
              value: String(this.value),
              choosegene: String(this.chooseGene),
              color1: String(this.color).split("#")[1],
              color2: String(this.color2).split("#")[1],
              dolog: this.doLog,
              doNP: this.doNP,
              plotwidth: this.pWidth,
              plotheight: this.pHeight,
            },
          })
          .then((response) => {
            if (response.data != "failed") {
              this.vnplot_visible = false;
              this.$notification["success"]({
                message: "Job done!",
                top: "100px",
                description:
                  "congratulations, " +
                  response.data +
                  ".pdf" +
                  " now is available!",
              });
              this.vnplotlinks =
                "http://research.gzsys.org.cn/perturbdb/data/temppPlot/" +
                response.data +
                ".pdf#zoom=50";
            } else {
              this.visible = false;
              this.vnplot_visible = false;
              this.vnplotlinks = null;
              this.$message.error(
                "Please check step1, and input an valid gene!",
                6
              );
            }
          });
      } else {
        this.$message.warning("Please enter at least one gene name.!", 6);
      }
    },
  },
  data() {
    return {
      // 文件的宽度
      pWidth: 8,
      pHeight: 8,
      //color #不得行
      color: "#AA4643",
      isShowColors: false,
      color2: "#4572a7",
      isShowColors2: false,
      yaxis:
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/customeGene.txt",
      //other params
      doLog: 0,
      doNP: 0,
      //vnplot
      vnplotlinks: null,
      vnplot_visible: false,
      // 加载
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //
      value: ["NT", this.$route.query.gene],
      chooseGene: "",
      visible: false,
    };
  },
  components: {
    "sketch-picker": Sketch,
  },
};
</script>

<style></style>
